import { useState } from "react";
import { ChevronDown, ArrowRight, Users } from "lucide-react";
import { Reveal } from "../components/Reveal";

export const SEMINAR_FAQS = [
  { q: "Is this seminar really free?", a: "Yes, 100% free — no hidden charges, no obligation to enroll in anything afterward." },
  { q: "Will this be online or in-person?", a: "It's live online (Zoom), so you can join from anywhere. Limited in-person seats at our Delhi campus (Preet Vihar) are available on request — just mention it on WhatsApp after registering." },
  { q: "I have zero tech background — will I still understand it?", a: "Yes, the seminar is designed for complete beginners, no prior knowledge required." },
  { q: "What if I can't attend live?", a: "No recording is shared — it's live-only, which keeps the Q&A honest. If you miss it, you'll be waiting for the next batch." },
  { q: "Do I need to bring or prepare anything?", a: "Just yourself and your questions — everything else will be covered live." },
];

export const SeminarFaqSection = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section className="py-20 sm:py-28" style={{ background: "var(--bg-primary)" }} data-testid="seminar-faq-section">
      <div className="max-w-3xl mx-auto px-5">
        <Reveal className="text-center">
          <span className="text-xs font-semibold tracking-widest uppercase" style={{ color: "var(--accent)" }}>FAQ</span>
          <h2 className="font-display mt-3 text-3xl md:text-4xl font-bold text-white leading-tight">Before You Ask</h2>
        </Reveal>
        <div className="mt-12 space-y-3">
          {SEMINAR_FAQS.map((f, i) => {
            const open = openIdx === i;
            return (
              <Reveal key={f.q} delay={i * 80}>
                <div className="rounded-xl overflow-hidden" style={{ background: "var(--bg-card)", border: "1px solid var(--input-border)" }} data-testid={`seminar-faq-item-${i}`}>
                  <button
                    data-testid={`seminar-faq-question-${i}`}
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 p-5 text-left"
                  >
                    <span className="font-display text-base font-semibold text-white">{f.q}</span>
                    <ChevronDown size={18} className={`faq-chevron shrink-0 ${open ? "open" : ""}`} style={{ color: "var(--accent)" }} />
                  </button>
                  <div className={`faq-answer ${open ? "open" : ""}`}>
                    <div>
                      <p className="px-5 pb-5 text-sm leading-relaxed" style={{ color: "var(--text-body)" }} data-testid={`seminar-faq-answer-${i}`}>{f.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export const SeminarFinalCta = ({ onCta }) => (
  <section className="py-20 sm:py-28" style={{ background: "var(--bg-secondary)" }} data-testid="seminar-final-cta-section">
    <div className="max-w-3xl mx-auto px-5 text-center">
      <Reveal>
        <h2 className="font-display text-4xl sm:text-5xl font-bold text-white leading-[1.15]" data-testid="seminar-final-headline">
          Seats Are Filling Up Fast. Reserve Yours Now.
        </h2>
      </Reveal>
      <Reveal delay={120}>
        <p className="mt-6 text-base md:text-lg leading-relaxed" style={{ color: "var(--text-body)" }} data-testid="seminar-final-body">
          This seminar happens live, only once. Miss it, and you'll be waiting for the next batch — while others walk
          away with clarity today.
        </p>
      </Reveal>
      <Reveal delay={240}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button data-testid="seminar-final-cta-button" onClick={onCta} className="cta-button inline-flex items-center gap-2 rounded-full px-9 py-4 text-base sm:text-lg font-bold w-full sm:w-auto justify-center">
            Reserve My Free Seat
            <ArrowRight size={20} />
          </button>
          <span
            className="inline-flex items-center gap-2 rounded-full px-6 py-4 text-sm font-semibold"
            style={{ border: "1px solid rgba(14, 217, 181, 0.3)", color: "var(--accent)" }}
            data-testid="seats-left-badge"
          >
            <Users size={18} />
            37 seats left
          </span>
        </div>
        <p className="mt-8 text-sm" style={{ color: "var(--text-muted)" }} data-testid="seminar-final-trust-line">
          Free · No obligation · Certificate of participation for all attendees
        </p>
      </Reveal>
    </div>
  </section>
);

export const SeminarStickyBar = ({ onCta, hidden }) => (
  <div
    data-testid="seminar-sticky-mobile-cta"
    className={`fixed bottom-0 inset-x-0 z-40 sm:hidden p-3 transition-transform duration-300 ${hidden ? "translate-y-full" : ""}`}
    style={{ background: "rgba(21, 27, 51, 0.92)", backdropFilter: "blur(12px)", borderTop: "1px solid var(--input-border)" }}
  >
    <button data-testid="seminar-sticky-cta-button" onClick={onCta} className="cta-button w-full rounded-full py-3.5 text-base font-bold">
      Reserve My Free Seat
    </button>
  </div>
);
